// export DsfHtml from './html.vue'

export const DsfHtml=dsf.defineLazyComponent('DsfHtml',()=>require('./html.vue'))
